import type { FaireProductEntity } from "../../entity_types/product";

export const p_ejeumwkmx2: FaireProductEntity = {
  token: "p_ejeumwkmx2",
  type: "product",
  name: "See You in Hell Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/7d3ca9c5f2531263f7f4f4728a49ca3db1dabfaf672bc690f07afc1d0f0dc37b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea441e549748a3b88d7e15dc501ef851d878046feb2ffcc6e61aac37d0ea8b15.jpeg",
    "https://cdn.faire.com/fastly/eb0209759c9a61cbd046ce4dc367c3b68f2a6e72c9d0c0bc1c9e360cff12f836.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/0b548775587421deb9b6727270928c9addb46a478daa73bc32f54114dfedfc13.jpeg",
    "https://cdn.faire.com/fastly/faddeff7d516fcfec266bd1cded85fbe786da1c3dfa90668638efeed66ab740e.jpeg"
  ],
  priceDollars: 6.75,
  description: "Make your sock game as fiery as your wit. Take a walk on the devilish side and catch up with your friends later. 🔥 🔥 🔥\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:58.185Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
